import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { HttpError } from "../httpError";
import { schoolFeeCatalogueKey } from "../../constants";
import { SchoolFeeCatalogueResult } from "../../models/schoolFee";

// The catalogue is journey B's entry and is unreachable on a searchable
// service (D-25). Nothing here falls through to it from a search that found
// nothing.
const useSchoolFeeCatalogue = ({
  coreServiceId,
  page,
  size,
  authorisation = "",
  enabled = true,
}: {
  coreServiceId: string;
  page?: number;
  size?: number;
  authorisation?: string;
  enabled?: boolean;
}) =>
  useQuery<SchoolFeeCatalogueResult, HttpError>(
    schoolFeeCatalogueKey(coreServiceId, { page, size }),
    () =>
      httpClient("schoolfee/catalogue", { authorisation }).get<
        SchoolFeeCatalogueResult
      >({ core_service_id: coreServiceId, page, size }),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: enabled && !!coreServiceId && !!authorisation,
    }
  );

export default useSchoolFeeCatalogue;
